<template>
  <div>
    <PHeader :version="2" size="md" :beta="config.beta" border>
      <template #logo>
        <img class="w-16" src="/logo.png" alt="Le parapheur" />
      </template>

      <template #navigation>
        <PNavigation>
          <PNavigationDropdown color="primary" label="Aide" :icon="RiQuestionLine">
            <PNavigationButton to="/user-guide" label="Guide d'utilisation" :icon="RiBook2Line" />
            <PNavigationButton label="Nous contacter" to="/contact" :icon="RiMessage3Line" />
          </PNavigationDropdown>

          <AppNotificationBox />

          <UserDropdown
            v-if="authStore.isAuthenticated"
            aria-label="Profil"
            data-sentry-id="AppUserDropdown"
            :version="2"
            color="primary"
            signOutStyle="link"
          >
            <template #myProfile>
              <PreferencesForm />
            </template>
          </UserDropdown>
        </PNavigation>
      </template>

      <template #mobile-icons>
        <PButton mode="tertiary-borderless" size="icon" to="/?searchPattern=">
          <OhVueIcon :name="searchIcon" scale="1.2" />
        </PButton>
      </template>
    </PHeader>
  </div>
</template>

<script setup lang="ts">
import {
  useConfig,
  PNavigation,
  PNavigationButton,
  useIcons,
  PHeader,
  PButton,
  PNavigationDropdown,
} from "@pasta/box-v2";
import AppNotificationBox from "../../app-notification-box/AppNotificationBox.vue";
import { useAuthStore, UserDropdown } from "@pasta/front-auth-v2";
import { type ParapheurConfig } from "../types";
import { RiQuestionLine, RiBook2Line, RiMessage3Line, RiSearchLine } from "oh-vue-icons/icons";
import PreferencesForm from "./PreferencesForm.vue";
import { OhVueIcon } from "oh-vue-icons";

const [searchIcon] = useIcons(RiSearchLine);

const config = useConfig<ParapheurConfig>();
const authStore = useAuthStore();
</script>
